import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockWastageReportData} from "./stock-wastage-report.data";

@Injectable()
export class StockWastageReportModel extends ReportModel<StockWastageReportData> {
    constructor(injector: Injector) {
        super(injector, StockWastageReportData);
    }
}
